// extracted by mini-css-extract-plugin
module.exports = {"newQuestion":"_34Ugq9S8UwUfU9go","questionSelector":"NHAYE4LAesCjj89H"};